import React from 'react';
import { FaStar, FaMoon, FaHeart, FaEye, FaBrain, FaHandPaper } from 'react-icons/fa';

const Skills = () => {
  const usingNow = [
    { name: 'Vedic Astrology', icon: <FaStar /> },
    { name: 'Kundli Analysis', icon: <FaMoon /> },
    { name: 'Palmistry', icon: <FaHandPaper /> },
    { name: 'Tarot Reading', icon: <FaEye /> },
    { name: 'Numerology', icon: <FaBrain /> },
    { name: 'Spiritual Guidance', icon: <FaHeart /> },
  ];

  const learning = [
    { name: 'Crystal Healing', icon: <FaStar /> },
    { name: 'Chakra Balancing', icon: <FaMoon /> },
    { name: 'Energy Reading', icon: <FaEye /> },
  ];

  const otherSkills = [
    { name: 'Sanskrit Knowledge', icon: <FaBrain /> },
    { name: 'Meditation Practice', icon: <FaHeart /> },
    { name: 'Spiritual Counseling', icon: <FaEye /> },
  ];

  return (
    <section id="skills" className="section-padding bg-white">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title">
            My <span className="gradient-text">Skills</span>
          </h2>
          <p className="section-subtitle">
            Explore my expertise in various astrological and spiritual practices that help me provide accurate and meaningful guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Using Now */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-center mb-8 font-heading">
              <span className="text-primary">Using Now:</span>
            </h3>
            <div className="space-y-4">
              {usingNow.map((skill, index) => (
                <div key={index} className="skill-tag flex items-center space-x-3 w-full justify-start">
                  <span className="text-lg">{skill.icon}</span>
                  <span>{skill.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Learning Now */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-center mb-8 font-heading">
              <span className="text-secondary">Learning Now:</span>
            </h3>
            <div className="space-y-4">
              {learning.map((skill, index) => (
                <div key={index} className="skill-tag flex items-center space-x-3 w-full justify-start bg-secondary/10 text-secondary hover:bg-secondary hover:text-white">
                  <span className="text-lg">{skill.icon}</span>
                  <span>{skill.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Other Skills */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-center mb-8 font-heading">
              <span className="text-accent">Other Skills:</span>
            </h3>
            <div className="space-y-4">
              {otherSkills.map((skill, index) => (
                <div key={index} className="skill-tag flex items-center space-x-3 w-full justify-start bg-accent/10 text-accent hover:bg-accent hover:text-white">
                  <span className="text-lg">{skill.icon}</span>
                  <span>{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-center mb-12 font-heading">
            Certifications & Training
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-xl text-center hover:shadow-lg transition-all duration-300">
              <FaStar className="text-primary text-3xl mx-auto mb-4" />
              <h4 className="font-semibold text-lg mb-2">Certified Vedic Astrologer</h4>
              <p className="text-gray-600 text-sm">Bharatiya Vidya Bhavan</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl text-center hover:shadow-lg transition-all duration-300">
              <FaEye className="text-secondary text-3xl mx-auto mb-4" />
              <h4 className="font-semibold text-lg mb-2">Advanced Tarot Reading</h4>
              <p className="text-gray-600 text-sm">International Tarot Foundation</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl text-center hover:shadow-lg transition-all duration-300">
              <FaHandPaper className="text-accent text-3xl mx-auto mb-4" />
              <h4 className="font-semibold text-lg mb-2">Palmistry & Face Reading</h4>
              <p className="text-gray-600 text-sm">Indian Institute of Palmistry</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
